module.exports = __webpack_public_path__ + "img/slide-2.860b8385.png";